import React from "react";
import { Container, Stack } from "react-bootstrap";
import facebook from "../../assets/images/facebook-logo-2019.svg";
import instagram from "../../assets/images/instagram.svg";
import linkedin from "../../assets/images/linkedin.svg";
import twitter from "../../assets/images/twitter.svg";

const TODIS_SIGN_IN_COVER = () => {


    return (
        <Container fluid className="todis-sign-in-cover-wrapper">
            <Container className="d-none d-md-block">
                <Stack direction="horizontal" gap={5} style={{ position: "relative", height: "100%" }}>
                    <div className="vl"></div>
                    <Stack gap={3} className="my-auto" style={{ position: "relative", backgroundColor: "#fff", padding: "1rem 0rem" }} >
                        {/* <div className="vl"></div> */}
                        <div className=""><a href="#"><img src="/assets/images/facebook-logo-2019.svg" width="40" /></a></div>
                        <div className=""><a href="#"><img src="/assets/images/instagram.svg" width="40" /></a></div>
                        <div className=""><a href="#"><img src="/assets/images/linkedin.svg" width="40" /></a></div>
                        <div className=""><a href="#"><img src="/assets/images/twitter.svg" width="40" /></a></div>
                    </Stack>
                    <Stack gap={1} className="my-auto">
                        <p className="todis-cover-portal-title">Transport Community Portal</p>
                        <h1 className="todis-cover-title todis-header">Transport Observatory Database/Information System (TODIS)</h1>
                        <p className="todis-cover-description">Monitor, analyse & visualize the indicative extensions of TEN-T core and comprehensive networks  to the Western Balkans</p>
                    </Stack>
                </Stack>
            </Container>
            <Container fluid className="p-0 d-block d-md-none">
                <Stack direction="horizontal" gap={5} style={{ position: "relative", height: "100%" }}>
                    <Stack gap={1} className="my-auto text-center">
                        <p className="todis-cover-portal-sm-title">Transport Community Portal</p>
                        <h1 className="todis-cover-sm-title todis-header">Transport Observatory Database/Information System (TODIS)</h1>
                        <p className="todis-cover-sm-description">Monitor, analyse & visualize the indicative extensions of TEN-T core and comprehensive networks  to the Western Balkans</p>
                    </Stack>
                </Stack>
            </Container>
        </Container>
    )
}

export default TODIS_SIGN_IN_COVER;